import React from 'react'
import { AuthProvider } from './AuthProvider'
import { CustomerProvider } from './CustomerProvider'
import { ThemeProvider } from './ThemeProvider'
import { NylasProvider } from '@nylas/nylas-react';

const Provider = ({ children }) => {
    return (
        <AuthProvider>
                <NylasProvider serverBaseUrl={''}>
                    <CustomerProvider>
                        <ThemeProvider>
                            {children}
                        </ThemeProvider>
                    </CustomerProvider>
                </NylasProvider>
        </AuthProvider>
    )
}

export default Provider
